export default "__VITE_ASSET__312d1b8e__"